"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var react_1 = __importDefault(require("react"));

var constants_1 = require("./constants");

exports.SmallModal = function (props) {
  var visible = props.visible,
      modalClose = props.modalClose;
  var title = constants_1.MODAL_CONSTANTS.TITLE,
      content = constants_1.MODAL_CONSTANTS.CONTENT;
  return react_1.default.createElement(components_lib_1.ContentPageModal, {
    visible: visible,
    closeAction: modalClose,
    scrollable: true
  }, react_1.default.createElement(components_lib_1.Title, {
    centered: true
  }, title), react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.normal
  }, content), react_1.default.createElement(components_lib_1.Paragraph, {
    size: components_lib_1.ParagraphSizeEnum.normal,
    centered: true
  }, react_1.default.createElement(content_parser_1.ParsedContent, {
    content: content
  })));
};